document.addEventListener('DOMContentLoaded', () => {
  const inventoryPopUpTrigger = document.querySelector('.inventory-popup-trigger');
  const inventoryPopUpTriggerId = document.querySelector('.inventory-popup-trigger').getAttribute('data-trigger');
  const inventoryPopUp = document.querySelector(`#${inventoryPopUpTriggerId}`);
  const inventoryPopUpOverlay = document.querySelector('.inventory-popup-overlay');
  const closeButton = inventoryPopUp.querySelector('.inventory-popup-title');
  const closeElements = [closeButton, inventoryPopUpOverlay];
  
  // Check if this is a high price item
  const isHighPrice = inventoryPopUp.getAttribute('data-high-price') === 'true';
  const storesCount = inventoryPopUp.dataset.storesCount;
  
  // Add appropriate text based on price and store count
  if (storesCount === '1') {
    inventoryPopUpTrigger.innerHTML += `<span style="text-decoration: underline;">${storesCount} winkel</span>`;
  } else {
    if (isHighPrice) {
      inventoryPopUpTrigger.innerHTML += `<span style="text-decoration: underline;">${storesCount} winkels & aan huis</span>`;
    } else {
      inventoryPopUpTrigger.innerHTML += `<span style="text-decoration: underline;">${storesCount} winkels</span>`;
    }
  }
  
  inventoryPopUpTrigger.addEventListener('click', () => {
    inventoryPopUp.classList.toggle('activePopup');
    inventoryPopUpOverlay.classList.toggle('activePopup');
  });
  closeElements.forEach((element) => {
    element.addEventListener('click', () => {
      inventoryPopUp.classList.remove('activePopup');
      inventoryPopUpOverlay.classList.remove('activePopup');
    });
  });
  const amsterdamTime = new Date().toLocaleString("en-US", { timeZone: "Europe/Amsterdam" });
  const currentDay = new Date(amsterdamTime).getDay();
  // Map days to section settings
  const daysMap = {
    0: 'sunday_open_hours',
    1: 'monday_open_hours',
    2: 'tuesday_open_hours',
    3: 'wednesday_open_hours',
    4: 'thursday_open_hours',
    5: 'friday_open_hours',
    6: 'saturday_open_hours'
  };
  // Get the open hours for the current day
  // document.querySelectorAll('.inventory-popup-store-hours').forEach(storeHoursElement => {
  //   const currentDayOpenHours = storeHoursElement.dataset[daysMap[currentDay]];
  //   storeHoursElement.innerHTML += `<span>${currentDayOpenHours}</span>`;
  // });
});